var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V80H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.035 66.8538L27.1569 63.1488C28.3381 65.2428 29.4125 67.0147 31.9897 67.0147C34.46 67.0147 36.0178 66.0484 36.0178 62.2897V36.7278H43.5356V62.3959C43.5356 70.1825 38.9713 73.7269 32.3119 73.7269C26.2978 73.7269 22.8069 70.6122 21.0347 66.8531M47.6191 66.0481L53.7403 62.5041C55.3519 65.1356 57.4463 67.0687 61.1513 67.0687C64.2666 67.0687 66.2528 65.5112 66.2528 63.3631C66.2528 60.7856 64.2122 59.8725 60.7753 58.3694L58.8963 57.5631C53.4722 55.2547 49.8744 52.3547 49.8744 46.2328C49.8744 40.5941 54.1703 36.2978 60.8831 36.2978C65.6625 36.2978 69.0994 37.9628 71.5694 42.3125L65.7156 46.0719C64.4266 43.7628 63.0309 42.85 60.8828 42.85C58.6809 42.85 57.2847 44.2462 57.2847 46.0719C57.2847 48.3272 58.6809 49.2406 61.9028 50.6369L63.7822 51.4422C70.1728 54.1813 73.7706 56.9734 73.7706 63.2559C73.7706 70.0228 68.4544 73.7278 61.3122 73.7278C54.3313 73.7278 49.8203 70.3984 47.6188 66.0484",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.1987b1225d8030d0d08b46f11b36f221.svg";
export { ForwardRef as ReactComponent };